<template>
    <div id="app-container">
        <div id="extension-payment-placeholder-pixPaymentGroup" class=" box-payment-option">
            <div class="">
                <div>
                    <div style="background-color: rgb(255, 230, 230); padding: 20px; margin: 0px 0px 20px;">
                        <div style="display: flex; flex-direction: row; align-items: center;">
                            <p style="margin: 0px; line-height: normal;">
                                Clique em Finalizar compra para gerar o QR CODE
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="openqrcode">
        <div class="VTEX-PIX__modal-background ">
            <div class="VTEX-PIX__modal-outer-container ">
                <div class="VTEX-PIX__modal-container">
                    <div class="VTEX-PIX__timer-body">
                        <div class="VTEX-PIX__pix-logo-container">
                            <img alt="pix-logo" src="https://master--lavillecasa.myvtex.com/_v/public/assets/v1/published/vtex.pix-payment@0.12.2/public/react/b578357407b9fc1b238c43bda0b9fc6e.png" width="180" height="64">
                        </div>
                        <div class="VTEX-PIX__qrcode-container">
                            <img alt="PIX QRCode" class="VTEX-PIX_qrcode-image" v-bind:src="'data:image;base64,' + qrcodeimagebase64">
                        </div>
                        <div class="VTEX-PIX__code-preview">{{qrcode}}</div>
                        <button type="button" @click="copyToClipboard" class="VTEX-PIX__button VTEX-PIX__button-icon VTEX-PIX__button-copy "><span>COPIAR CÓDIGO</span><span><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.6001 4.60001V3C4.6001 1.89543 5.49553 1 6.6001 1H11.0002C12.1048 1 13.0002 1.89543 13.0002 3V7.40001C13.0002 8.50458 12.1048 9.40001 11.0002 9.40001H9.40016" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"></path><path d="M1 6.59999L1 11C1 12.1046 1.89543 13 3 13H7.4001C8.50467 13 9.4001 12.1046 9.4001 11V6.59999C9.4001 5.49542 8.50467 4.59999 7.4001 4.59999H3C1.89543 4.59999 1 5.49542 1 6.59999Z" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"></path></svg></span></button>
                        <div class="VTEX-PIX__container-info">
                            <div class="VTEX-PIX__container-info-head">Escaneie o código com seu celular ou copie com o botão acima.</div>
                            <div class="VTEX-PIX__container-info-description">Abra o app do seu banco no celular, escolha Pix e aponte a câmera para o código</div>
                        </div>
                    </div>
                </div>
                <div class="VTEX-PIX__footer">
                    <!--<span>Valor da compra</span><span class="VTEX-PIX_footer-value">R$ </span>-->
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped src="@/assets/css/checkout-paymentcreditcard.module.css"></style>
<style scoped src="@/assets/css/checkout-paymentpix.module.css"></style>
<script>
    import formatter from "@/mixins/formatter.js";
    export default {
        name: 'payment-pix',
        props: ['enablePaymentButton'],
        mixins: [formatter],
        data: () => ({
            paymentPix: {
            },
            qrcode: '',
            qrcodeimagebase64: '',
            openqrcode: false
        }),
        mounted() {

        },
        computed: {
        },
        methods: {
            getData() {
                this.enablePaymentButton(true);
            },
            openPixQrCode(qrcode, qrcodeimagebase64) {
                this.qrcode = qrcode;
                this.qrcodeimagebase64 = qrcodeimagebase64;
                this.openqrcode = true;
            },
            async copyToClipboard() {
                var self = this;
                try {
                    await navigator.clipboard.writeText(self.qrcode);
                    console.log('Copied');
                } catch ($e) {
                    console.log('Cannot copy');
                }
            }
        }
    }
</script>

